import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingScreen from '~/components/LoadingScreen';
import { RouteConfig } from '~/routes/routeConfig';
import { isNotEmpty } from '~/utils/helpers';
import useAuth from '../hooks/useAuth';

export const AuthGuard: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { loading, loggedIn, user } = useAuth();
  const location = useLocation();

  const redirectUrlSearchParams = new URLSearchParams();
  if (location.pathname !== RouteConfig.AppRoot.buildLink() || location.search.length !== 0) {
    redirectUrlSearchParams.set('rd', location.pathname + location.search);
  }

  if (loading) {
    return <LoadingScreen />;
  }

  if (!loggedIn) {
    const path = RouteConfig.Logout.buildLink();
    const queryString = redirectUrlSearchParams.toString();
    const to = isNotEmpty(queryString) ? `${path}?${queryString}` : path;

    return <Navigate to={to} />;
  }

  const termsAcceptancePending = !user || !user.termsAndConditionsAgreed || !user.privacyPolicyAgreed;
  if (termsAcceptancePending && location.pathname !== RouteConfig.TermsAcceptance.buildLink()) {
    const path = RouteConfig.TermsAcceptance.buildLink();
    const queryString = redirectUrlSearchParams.toString();
    const to = isNotEmpty(queryString) ? `${path}?${queryString}` : path;

    return <Navigate to={to} />;
  }

  // Note: 2FA is enforced by the backend at login (the MFA challenge, phase 2),
  // not by a soft FE gate here. We no longer read `user.mfaRequired` to prompt.
  return <>{children}</>;
};
